import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { SlideCarousel } from "./components";
import Swal from "sweetalert2";
import "react-responsive-carousel/lib/styles/carousel.css"; // requires a loader

import activeOrderCreation from "../../../../../assets/images/active-order-create.png";

import shopify1 from "../../../../../assets/images/shopify/shopify1.png";
import shopify2 from "../../../../../assets/images/shopify/shopify2.png";
import shopify3 from "../../../../../assets/images/shopify/shopify3.png";
import shopify4 from "../../../../../assets/images/shopify/shopify4.png";
import shopify5 from "../../../../../assets/images/shopify/shopify5.png";
import shopify6 from "../../../../../assets/images/shopify/shopify6.png";
import shopify7 from "../../../../../assets/images/shopify/shopify7.png";
import shopify8 from "../../../../../assets/images/shopify/shopify8.png";
import shopify9 from "../../../../../assets/images/shopify/shopify9.png";
import shopify10 from "../../../../../assets/images/shopify/shopify10.png";
import shopify11 from "../../../../../assets/images/shopify/shopify11.png";
import shopify12 from "../../../../../assets/images/shopify/shopify12.png";
import shopify14 from "../../../../../assets/images/shopify/shopify14.png";
import shopify15 from "../../../../../assets/images/shopify/shopify15.png";
import shopify16 from "../../../../../assets/images/shopify/shopify16.png";

import styles from "./styles.module.scss";

const SHOPIFY_SCOPES = "read_all_orders,read_analytics,read_app_proxy,write_app_proxy,read_apps,read_assigned_fulfillment_orders,write_assigned_fulfillment_orders,read_audit_events,read_customer_events,read_cart_transforms,write_cart_transforms,read_all_cart_transforms,read_validations,write_validations,read_cash_tracking,write_cash_tracking,read_channels,write_channels,read_checkout_branding_settings,write_checkout_branding_settings,write_checkouts,read_checkouts,read_companies,write_companies,read_custom_fulfillment_services,write_custom_fulfillment_services,read_custom_pixels,write_custom_pixels,read_customers,write_customers,read_customer_data_erasure,write_customer_data_erasure,read_customer_payment_methods,read_customer_merge,write_customer_merge,read_delivery_customizations,write_delivery_customizations,read_price_rules,write_price_rules,read_discounts,write_discounts,read_discounts_allocator_functions,write_discounts_allocator_functions,read_discovery,write_discovery,write_draft_orders,read_draft_orders,read_files,write_files,read_fulfillment_constraint_rules,write_fulfillment_constraint_rules,read_fulfillments,write_fulfillments,read_gift_card_transactions,write_gift_card_transactions,read_gift_cards,write_gift_cards,write_inventory,read_inventory,write_inventory_shipments,read_inventory_shipments,write_inventory_shipments_received_items,read_inventory_shipments_received_items,write_inventory_transfers,read_inventory_transfers,read_legal_policies,write_legal_policies,read_delivery_option_generators,write_delivery_option_generators,read_locales,write_locales,write_locations,read_locations,read_marketing_integrated_campaigns,write_marketing_integrated_campaigns,write_marketing_events,read_marketing_events,read_markets,write_markets,read_markets_home,write_markets_home,read_merchant_managed_fulfillment_orders,write_merchant_managed_fulfillment_orders,read_metaobject_definitions,write_metaobject_definitions,read_metaobjects,write_metaobjects,read_online_store_navigation,write_online_store_navigation,read_online_store_pages,write_online_store_pages,write_order_edits,read_order_edits,read_orders,write_orders,write_packing_slip_templates,read_packing_slip_templates,write_payment_mandate,read_payment_mandate,read_payment_terms,write_payment_terms,read_payment_customizations,write_payment_customizations,read_pixels,write_pixels,read_privacy_settings,write_privacy_settings,read_product_feeds,write_product_feeds,read_product_listings,write_product_listings,read_products,write_products,read_publications,write_publications,read_purchase_options,write_purchase_options,write_reports,read_reports,read_resource_feedbacks,write_resource_feedbacks,read_returns,write_returns,read_script_tags,write_script_tags,read_shopify_payments_provider_accounts_sensitive,read_shipping,write_shipping,read_shopify_payments_accounts,read_shopify_payments_payouts,read_shopify_payments_bank_accounts,read_shopify_payments_disputes,write_shopify_payments_disputes,read_content,write_content,read_store_credit_account_transactions,write_store_credit_account_transactions,read_store_credit_accounts,write_own_subscription_contracts,read_own_subscription_contracts,write_theme_code,read_themes,write_themes,read_third_party_fulfillment_orders,write_third_party_fulfillment_orders,read_translations,write_translations";

const SHOPIFY_REDIRECT_URL = "app.brcomerce.com.br/integracao/shopify";

const TutorialShopify = () => {
  const history = useHistory();
  const [copiedScopes, setCopiedScopes] = useState(false);
  const [copiedUrl, setCopiedUrl] = useState(false);

  const handleCopy = async (text, type) => {
    try {
      await navigator.clipboard.writeText(text);
      if (type === "scopes") {
        setCopiedScopes(true);
        setTimeout(() => setCopiedScopes(false), 2000);
      } else {
        setCopiedUrl(true);
        setTimeout(() => setCopiedUrl(false), 2000);
      }
    } catch {
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível copiar. Tente novamente."
      });
    }
  };

  // Passo 1: Menu Partners, página Apps, modal Criar app
  const stepsCreateApp = [
    { image: shopify1 },
    { image: shopify2 },
    { image: shopify3 },
  ];

  // Passo 2: Config escopos, config URLs
  const stepsConfigScopes = [
    { image: shopify4 },
    { image: shopify5 },
  ];

  // Passo 3: Selecionar loja, dashboard do app (instalar)
  const stepsInstallApp = [
    { image: shopify6 },
    { image: shopify7 },
  ];

  // Passo 4: Form BRCom vazio, URL da loja, form preenchido, sucesso
  const stepsBrcomConfig = [
    { image: shopify8 },
    { image: shopify12 },
    { image: shopify11 },
    { image: shopify9 },
    { image: shopify10 },
  ];

  // Passo 5: Config remetente, seguro, frete customizado
  const stepsSenderConfig = [
    { image: shopify14 },
    { image: shopify15 },
    { image: shopify16 },
  ];

  return (
    <main className={styles.container}>
      <div className={styles.content}>
        <header className={styles.contentHeader}>
          <p>Como fazer a integração?</p>
        </header>
        <div className={styles.contentBody}>
          <section className={styles.contentSection}>
            <h4>
              Passo a passo para conectar sua plataforma Shopify à BRCom
            </h4>

            <div className={styles.bulletpoint}>
              <span>1</span>
              <p>
                No painel da Shopify, acesse <b>Apps</b> e clique em <b>Criar app</b>.
                Escolha a opção <b>"Começar pelo Dev Dashboard"</b>, dê um nome ao app e clique em <b>Criar</b>.
              </p>
            </div>

            <SlideCarousel steps={stepsCreateApp} />

            <div className={styles.bulletpoint}>
              <span>2</span>
              <p>
                Nas <b>Configurações</b> do app, cole os escopos no campo <b>"Escopos"</b> e
                a URL de redirecionamento no campo <b>"URLs de redirecionamento"</b>. Depois clique em <b>Lançar</b>.
              </p>
            </div>

            <div className={styles.copyActions}>
              <button
                className={styles.copyButton}
                onClick={() => handleCopy(SHOPIFY_SCOPES, "scopes")}
              >
                {copiedScopes ? "Escopos copiados!" : "Copiar escopos"}
              </button>
              <button
                className={styles.copyButton}
                onClick={() => handleCopy(SHOPIFY_REDIRECT_URL, "url")}
              >
                {copiedUrl ? "URL copiada!" : "Copiar URL de redirecionamento"}
              </button>
            </div>

            <SlideCarousel steps={stepsConfigScopes} />

            <div className={styles.bulletpoint}>
              <span>3</span>
              <p>
                Instale o app na loja e copie o <b>Client ID</b> e o <b>Client Secret</b> do app.
              </p>
            </div>

            <SlideCarousel steps={stepsInstallApp} />

            <div className={styles.bulletpoint}>
              <span>4</span>
              <p>
                Agora na plataforma da BRCom, vá em <b>Integrações</b> e selecione <b>Shopify</b>.
                Cole o <b>Client ID</b>, o <b>Client Secret</b> e a <b>URL da loja</b> (ex: minhaloja.myshopify.com) nos campos indicados e clique em <b>Ativar</b>.
              </p>
            </div>

            <SlideCarousel steps={stepsBrcomConfig} />

            <div className={styles.bulletpoint}>
              <span>5</span>
              <p>
                Configure os dados do remetente, se deseja seguro.
                <br></br>
                O frete customizado serve para importar pedidos que não foram cotados previamente pela BRCom.
                <br></br>
                Essas configurações serão aplicadas em todos os pedidos importados pela BRCom.
              </p>
            </div>

            <SlideCarousel steps={stepsSenderConfig} />

            <div className={styles.bulletpoint}>
              <span>6</span>
              <p>
                Pronto agora é só <b>Salvar</b> a integração e aproveitar nossas opções
                de frete. <br />
              </p>
            </div>

            <div className={styles.bulletpoint}>
              <span>7</span>
              <p>
                Caso queira desativar a criação de pedido nessa integração, vire a chave para "Desativado"
                <br></br>
                As demais funcionalidades relacionadas a essa integração continuarão ativas.
              </p>
            </div>

            <div className={styles.imgs}>
              <img
                src={activeOrderCreation}
                alt="activeOrderCreation"
                className={styles.cardImage}
              />
            </div>

            <button
              onClick={() => history.push("/integracoes")}
              className={`${styles.button} ${styles.btnBack}`}
            >
              Voltar
            </button>
          </section>
        </div>
      </div>
    </main>
  );
};

export { TutorialShopify };
